
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect";
import { flash_alert } from 'components/App';
import VisitInstallationQuestionnaire from 'components/services/visits/VisitInstallationQuestionnaire';

import { createStyles, makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField'

// Card
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
// Dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

// Upload components
import { DropzoneArea } from 'material-ui-dropzone';
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate';
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';
import VisibilityIcon from '@material-ui/icons/Visibility';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Image from 'material-ui-image';

//translation
import { useTranslation } from 'react-i18next';



import { SRLWrapper } from "simple-react-lightbox";

import {csrf, headers, money_format, date_event_format, date_difference_in_hours, api_token, site_url, payment_channel_label} from "constants/csrf"

const useStyles = makeStyles((theme) => ({

    buttonProgress: {
        position: 'relative',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
  }));



function VisitCheckList(props){
    const {t} = useTranslation();
    const classes = useStyles();
    const [checked, setChecked] = useState((props.visit.customer_products.length > 0 && props.visit.customer_products[0].id || ""));
    const [selectedCustomerProduct, setSelectedCustomerProduct] = useState((props.visit.customer_products && props.visit.customer_products[0] || {}));
    const [selectedVisitCustomerProduct, setSelectedVisitCustomerProduct] = useState((props.visit.visit_customer_products && props.visit.visit_customer_products[0] || {}));

    const [checklists, setChecklists] = useState([])
    const [images, setImages] = useState([])
    const [uploadedFiles, setUploadedFiles] = useState([])
    const [isUploading, setIsUploading] = useState(false)
    const [showUploader, setShowUploader] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [deletingImageId, setDeletingImageId] = useState(null)
    const [descriptionErrors, setDescriptionErrors] = useState([])
    const isVisitCompleted = props.visit && props.visit.status === 'Visita completada';
    const isServiceClosed = props.serviceStatusLabel === "Finalizado" || props.serviceStatusLabel === "Completado" || isVisitCompleted;

    // Delete image dialog
    const [openDeleteImageDialog, setOpenDeleteImageDialog] = React.useState(false);
    const [currentDeleteImage, setCurrentDeleteImage] = React.useState("");

    // View image modal
    const [openViewImageModal, setOpenViewImageModal] = React.useState(false);
    const [viewImageData, setViewImageData] = React.useState(null);
    const [copySuccess, setCopySuccess] = React.useState(false);

    const handleOpenViewImage = (image, descriptionText) => {
        setViewImageData({ ...image, displayDescription: descriptionText });
        setOpenViewImageModal(true);
        setCopySuccess(false);
    };

    const handleCloseViewImage = () => {
        setOpenViewImageModal(false);
        setViewImageData(null);
        setCopySuccess(false);
    };

    const handleCopyDescription = async () => {
        if (viewImageData?.displayDescription) {
            try {
                await navigator.clipboard.writeText(viewImageData.displayDescription);
                setCopySuccess(true);
                setTimeout(() => setCopySuccess(false), 2000);
            } catch (err) {
                console.error('Failed to copy:', err);
            }
        }
    };

    const handleClickOpenImageDialog = (image_id) => {
       setCurrentDeleteImage(image_id)
       setOpenDeleteImageDialog(true);
    };

    const handleCloseImageDialog = () => {
        setOpenDeleteImageDialog(false);
    };

    // Load images for the initially selected product
    useEffect(() => {
        if (selectedCustomerProduct && selectedCustomerProduct.id) {
            getProductImages(selectedCustomerProduct);
        }
    }, []);

    function handleToggle(customer_product, visit_customer_product){
        setChecked(customer_product.id)
        setSelectedCustomerProduct(customer_product)
        setSelectedVisitCustomerProduct(visit_customer_product)
    }


    useEffect(() => {
        if (selectedCustomerProduct && selectedCustomerProduct.id) {
            setChecklists(selectedCustomerProduct.customer_product_checklists || [])
            getProductImages(selectedCustomerProduct)
        } else {
            setChecklists([])
            setImages([])
        }
    }, [selectedCustomerProduct]);


    function getProductImages(customer_product){
        var url = `/api/v1/file_resources/${customer_product.id}/checklist_product_images?visit_id=${props.visit.id}`
        setIsLoading(true);
        fetch(url).then((response) => response.json())
        .then((json) => {
            if(json.data)
            {
                setImages(json.data)
            }
            setIsLoading(false)
        })
        .catch((error) => console.error(error) && setIsLoading(false));
      }

    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64String = reader.result.split(',')[1];
                resolve({
                    uri_64: base64String,
                    name: file.name,
                    mime: file.type,
                });
            };
            reader.onerror = error => reject(error);
        });
    }

    async function onServiceChangeFiles(e) {
        if (e.length > 0) {
            const dT = [];
            e.forEach(async function(item) {
                await getBase64(item)
                    .then((encFile) => {
                        dT.push({
                            ...encFile,
                            description: '' // Initialize with empty description
                        })
                        setUploadedFiles(dT)
                    }).catch(error => console.log("error"));
            });
        } else {
            setUploadedFiles([]);
        }
    }

    function handleDescriptionChange(index, description) {
        const updatedFiles = [...uploadedFiles];
        updatedFiles[index].description = description;
        setUploadedFiles(updatedFiles);

        // Clear error for this field if user enters a description
        if (descriptionErrors.includes(index) && description.trim() !== '') {
            setDescriptionErrors(prev => prev.filter(i => i !== index));
        }
    }

    function validateDescriptions() {
        const errors = [];
        uploadedFiles.forEach((file, index) => {
            if (!file.description || file.description.trim() === '') {
                errors.push(index);
            }
        });
        setDescriptionErrors(errors);
        return errors.length === 0;
    }


    async function handleUploadImages() {
        if (!selectedCustomerProduct || !selectedCustomerProduct.id) {
            flash_alert("", "Por favor seleccione un producto primero", "error");
            return;
        }

        // Validate that all images have descriptions
        if (!validateDescriptions()) {
            flash_alert("", "Todas las imágenes deben tener una descripción", "error");
            return;
        }

        setIsUploading(true);

        try {
            const payload = {
                customer_product_id: selectedCustomerProduct.id,
                visit_id: props.visit.id,
                // Include existing checklist answers to avoid overwriting
                answers: checklists?.map(checklist => ({
                    checklist_id: String(checklist.checklist.id),
                    answer: checklist.answer,
                    background: checklist.background
                })) || [],
                // Add the new images
                images: uploadedFiles.map(file => {
                    return {
                        uri_64: file.uri_64,
                        filename: file.name,
                        mime: file.mime,
                        description: file.description
                    };
                }),
                preVisit: true,
                status: selectedCustomerProduct.status
            };

            const response = await fetch(`/api/v1/customer_product_checklists/${selectedCustomerProduct.id}/answers`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrf
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                flash_alert("", "Imágenes subidas correctamente", "success");
                setTimeout(() => {
                    getProductImages(selectedCustomerProduct);
                }, 500);
                setUploadedFiles([]);
                setShowUploader(false);
            } else {
                const errorData = await response.json().catch(() => ({}));
                console.error('Upload failed:', response.status, errorData);
                flash_alert("", "Error al subir las imágenes", "error");
            }
        } catch (error) {
            console.error("Upload error:", error);
            flash_alert("", "Error al subir las imágenes", "error");
        } finally {
            setIsUploading(false);
        }
    }

    function handleMessage(message, type) {
        if (type == "error") {
            // Check if it's a file size error or file count error
            if (message && message.includes('File is too big')) {
                flash_alert("Error", "El archivo excede el tamaño máximo permitido de 10 MB. Por favor, seleccione una imagen más pequeña.", "error");
            } else if (message && message.includes('Maximum allowed number of files exceeded')) {
                flash_alert("Error", "Ha excedido el límite de 15 imágenes. Por favor, seleccione hasta 15 archivos como máximo.", "error");
            } else {
                flash_alert("Error", "Error al cargar el archivo. Verifique que el archivo sea válido y no exceda los límites permitidos.", "error");
            }
        }
    }

    async function handleDownloadImage(image, event) {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }

        try {
            // Get file extension from URL or default to jpg
            const urlParts = image.resource_url.split('.');
            const extension = urlParts.length > 1 ? urlParts[urlParts.length - 1].split('?')[0] : 'jpg';
            const filename = image.description ? `${image.description}.${extension}` : `checklist-image-${image.id}.${extension}`;

            // Try direct download first (works if same origin or CORS enabled)
            const link = document.createElement('a');
            link.href = image.resource_url;
            link.download = filename;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();

            setTimeout(() => {
                document.body.removeChild(link);
            }, 100);

        } catch (error) {
            console.error('Download error:', error);
            flash_alert("", "Error al descargar la imagen", "error");
        }
    }

    async function handleDeleteImage(image) {
        setDeletingImageId(image.id);
        setOpenDeleteImageDialog(false);

        try {
            const response = await fetch(`/api/v1/file_resources/${image.id}`, {
                method: 'DELETE',
                headers: {
                    'X-CSRF-Token': csrf,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                flash_alert("", "Imagen eliminada correctamente", "success");
                // Refresh images
                if (selectedCustomerProduct && selectedCustomerProduct.id) {
                    getProductImages(selectedCustomerProduct);
                }
            } else {
                const errorData = await response.json().catch(() => ({}));
                console.error('Delete failed:', response.status, errorData);
                flash_alert("", "Error al eliminar imagen", "error");
            }
        } catch (error) {
            console.error('Delete error:', error);
            flash_alert("", "Error al eliminar imagen", "error");
        } finally {
            setDeletingImageId(null);
            setCurrentDeleteImage(null);
        }
    }


	return (
		<React.Fragment>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <p className="service-subtitle">{t('services.visits.visit.checkList.title')}</p>
                        </Grid>
                    </Grid>


                    <List>
                    {props.visit.customer_products && props.visit.customer_products.map((customer_product) => {
                    const listId = `list-visit-products-${props.visit.id}-${customer_product.id}`;
                    const labelId = `visit-products-${props.visit.id}-${customer_product.id}`;
                    const visit_customer_product = props.visit.visit_customer_products.find(vcp => vcp.customer_product_id == customer_product.id);

                    return (
                    <ListItem key={listId} role={undefined} dense button onClick={() => handleToggle(customer_product, visit_customer_product)}>
                        <ListItemIcon className="service-address-label">
                        <FormControlLabel value={customer_product.id} control={<Radio color="primary"/>} label="" checked={checked == customer_product.id}
                            tabIndex={-1}
                        />
                        </ListItemIcon>
                        <ListItemText
                            id={labelId}
                            secondary={
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={4}>
                                        <span className="visit-summary-1">{t('visits.checkList.name')}</span><br/>
                                        <span className="visit-summary-2">{customer_product.product.name}</span>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <span className="visit-summary-1">{t('services.visits.visit.checkList.tnr')}</span><br/>
                                        <span className="visit-summary-2">{customer_product.product.tnr}</span>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <span className="visit-summary-1">{t('services.visits.visit.checkList.id')}</span><br/>
                                        <span className="visit-summary-2">{customer_product.serial_id}</span>
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        <span className="visit-summary-1">{t('services.visits.visit.checkList.status')}</span><br/>
                                        <span className="visit-summary-2">{customer_product.status}</span>
                                    </Grid>
                                </Grid>
                            }
                        />


                        <ListItemSecondaryAction>

                        </ListItemSecondaryAction>
                    </ListItem>
                    );
                })}

                </List>

                {/* Installation Questionnaire - New editable questionnaire (per product) */}
                <Grid className={"mg-t-15"} container spacing={1}>
                    <Grid item xs={12}>
                        <VisitInstallationQuestionnaire
                            visitCustomerProduct={selectedVisitCustomerProduct}
                            key={selectedVisitCustomerProduct?.id || 'no-product'}
                            readOnly={isServiceClosed}
                        />
                    </Grid>
                </Grid>

                {/* Old read-only checklist display - HIDDEN, replaced by VisitInstallationQuestionnaire
                <Grid className={"mg-t-15"} container spacing={1}>
                    <Grid item xs={12}>
                        <p className="service-subtitle">{t('services.visits.visit.checkList.questionnaire')}</p>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={1}>
                        {checklists &&
                            checklists.length > 0 &&
                                checklists.map((checklist,index) => {
                                const listId = `checklist-${checklist.id}`;

                                return (
                                    <Grid key={listId} item xs={12} sm={6} className="checklist-block">
                                        <span className="checklist-question">{index+1}. {checklist.checklist.question}</span><br/>
                                        <span className="checklist-answer">{checklist.answer}</span>
                                        <span className="checklist-additionals">{t('services.visits.visit.checkList.coments')}</span><br/>
                                        <span className="checklist-background">{checklist.background}</span>
                                    </Grid>
                                );
                                })
                            ||
                            <Grid item xs={12}>
                                <span className="visit-summary-2">{t('services.visits.visit.checkList.noCheckList')}</span>
                            </Grid>
                        }
                        </Grid>
                    </Grid>
                END OF HIDDEN SECTION */}

                <SRLWrapper>
                <Grid className={"mg-t-15"} container spacing={2}>
                        {images.length > 0 &&
                            <Grid item xs={12}>
                                <p className="service-p">Archivos cargados</p>
                            </Grid>
                        }
                        {images && images.map((image) => {
                            const labelId = `file-list-label-${image.id}`;

                            // Extract description from filename
                            let descriptionText = '';

                            // Try to get filename from description field first
                            let rawFilename = image.description;

                            // If description is null, extract filename from resource_url
                            if (!rawFilename && image.resource_url) {
                                const urlParts = image.resource_url.split('/');
                                rawFilename = decodeURIComponent(urlParts[urlParts.length - 1]);
                            }

                            // Remove file extension to get description
                            if (rawFilename) {
                                const parts = rawFilename.split('.');
                                descriptionText = parts.length > 1 ? parts.slice(0, -1).join('.') : rawFilename;
                            }

                            return (
                                <Grid key={labelId} item xs={6} sm={4} md={3}>
                                    <Card>
                                        <CardActionArea>
                                                <a href={image.resource_url}>
                                                    <Image
                                                        src={image.resource_url}
                                                        className="file-image"
                                                        srl_gallery_image="true"
                                                    />
                                                </a>
                                        </CardActionArea>
                                        {
                                        <CardActions style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', flexDirection: 'column', alignItems: 'stretch' }}>
                                            <div style={{ marginBottom: '8px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={descriptionText}>
                                                <a target="_blank" href={image.resource_url} className="mdl-navigation__link brand-link" style={{ fontSize: '12px' }}>
                                                    {descriptionText || 'Sin descripción'}
                                                </a>
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <IconButton
                                                    size="small"
                                                    color="primary"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        e.preventDefault();
                                                        handleOpenViewImage(image, descriptionText);
                                                    }}
                                                    title="Ver imagen"
                                                >
                                                    <VisibilityIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton
                                                    size="small"
                                                    color="primary"
                                                    onClick={(e) => handleDownloadImage(image, e)}
                                                    title="Descargar"
                                                    disabled={deletingImageId === image.id}
                                                >
                                                    <GetAppIcon fontSize="small" />
                                                </IconButton>
                                                <IconButton
                                                    size="small"
                                                    color="secondary"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        e.preventDefault();
                                                        handleClickOpenImageDialog(image.id);
                                                        setCurrentDeleteImage(image);
                                                    }}
                                                    title="Eliminar"
                                                    disabled={deletingImageId === image.id || isServiceClosed}
                                                >
                                                    {deletingImageId === image.id ? (
                                                        <CircularProgress size={20} color="secondary" />
                                                    ) : (
                                                        <DeleteIcon fontSize="small" />
                                                    )}
                                                </IconButton>
                                            </div>
                                        </CardActions>

                                        }
                                    </Card>
                                </Grid>
                            );
                        })}

                        {/* Upload Card */}
                        <Grid item xs={6} sm={4} md={3}>
                            <Card style={{
                                height: '100%',
                                minHeight: '200px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: '2px dashed #2196f3',
                                backgroundColor: '#f8f9ff',
                                cursor: 'pointer'
                            }}>
                                <CardActionArea
                                    onClick={() => !isServiceClosed && setShowUploader(true)}
                                    disabled={isServiceClosed}
                                    style={{
                                        height: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexDirection: 'column',
                                        padding: '20px',
                                        opacity: isServiceClosed ? 0.5 : 1
                                    }}
                                >
                                    <AddPhotoAlternateIcon style={{ fontSize: '48px', color: isServiceClosed ? '#999' : '#2196f3', marginBottom: '10px' }} />
                                    <p style={{ margin: 0, color: isServiceClosed ? '#999' : '#2196f3', fontWeight: '500', fontSize: '14px', textAlign: 'center' }}>
                                        Subir imágenes
                                    </p>
                                </CardActionArea>
                            </Card>
                        </Grid>

                    {/* Delete Image Dialog */}
                    <Dialog open={openDeleteImageDialog} onClose={handleCloseImageDialog} aria-labelledby="form-dialog-title">
                        <DialogTitle id="form-dialog-title">Eliminar foto</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                ¿Está seguro que desea eliminar este archivo?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseImageDialog} color="primary">
                                Cancelar
                            </Button>
                            <Button onClick={() => handleDeleteImage(currentDeleteImage)} color="secondary" variant="contained">
                                Eliminar
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {/* View Image Modal */}
                    <Dialog
                        open={openViewImageModal}
                        onClose={handleCloseViewImage}
                        maxWidth="md"
                        fullWidth
                    >
                        <DialogTitle style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            Ver imagen
                        </DialogTitle>
                        <DialogContent>
                            {viewImageData && (
                                <>
                                    <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                                        <img
                                            src={viewImageData.resource_url}
                                            alt={viewImageData.displayDescription || 'Imagen'}
                                            style={{ maxWidth: '100%', maxHeight: '60vh', objectFit: 'contain' }}
                                        />
                                    </div>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        padding: '12px',
                                        backgroundColor: '#f5f5f5',
                                        borderRadius: '4px',
                                        marginTop: '8px'
                                    }}>
                                        <div style={{ flex: 1, marginRight: '12px' }}>
                                            <strong>Descripción:</strong>
                                            <p style={{ margin: '4px 0 0 0', wordBreak: 'break-word' }}>
                                                {viewImageData.displayDescription || 'Sin descripción'}
                                            </p>
                                        </div>
                                        {viewImageData.displayDescription && (
                                            <Tooltip title={copySuccess ? "¡Copiado!" : "Copiar descripción"}>
                                                <IconButton
                                                    onClick={handleCopyDescription}
                                                    color={copySuccess ? "primary" : "default"}
                                                    size="small"
                                                >
                                                    <FileCopyIcon />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </div>
                                </>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseViewImage} color="primary" variant="contained">
                                Cerrar
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {/* Upload Dialog */}
                    <Dialog
                        open={showUploader}
                        onClose={() => setShowUploader(false)}
                        maxWidth="md"
                        fullWidth
                        fullScreen={window.innerWidth < 600}
                    >
                        <DialogTitle>Subir imágenes del producto</DialogTitle>
                        <DialogContent style={{ paddingBottom: '20px' }}>
                            <DropzoneArea
                                name='checklist_images'
                                dropzoneText={t('services.visits.fileUploadInstructions')}
                                onChange={onServiceChangeFiles}
                                showPreviews={true}
                                showPreviewsInDropzone={false}
                                useChipsForPreview
                                previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                                previewText={t('payments.selectedFiles')}
                                filesLimit={15}
                                showAlerts={false}
                                maxFileSize={10000000}
                                alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                                onAlert={handleMessage}
                            />
                            {uploadedFiles.length > 0 && (
                                <div style={{ marginTop: '20px' }}>
                                    <p style={{ marginBottom: '10px', fontWeight: '500' }}>Descripciones (obligatorias):</p>
                                    {uploadedFiles.map((file, index) => (
                                        <TextField
                                            key={index}
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            label={`Descripción para ${file.name} *`}
                                            value={file.description || ''}
                                            onChange={(e) => handleDescriptionChange(index, e.target.value)}
                                            style={{ marginBottom: '10px' }}
                                            placeholder="Escriba una descripción para esta imagen"
                                            required
                                            inputProps={{ maxLength: 400 }}
                                            error={descriptionErrors.includes(index)}
                                            helperText={descriptionErrors.includes(index) ? "La descripción es obligatoria" : `${(file.description || '').length}/400`}
                                        />
                                    ))}
                                </div>
                            )}
                        </DialogContent>
                        <DialogActions style={{ padding: '16px' }}>
                            <Button onClick={() => setShowUploader(false)} color="secondary">
                                Cancelar
                            </Button>
                            <Button
                                onClick={handleUploadImages}
                                color="primary"
                                disabled={isUploading || uploadedFiles.length === 0 || uploadedFiles.some(f => !f.description?.trim()) || isServiceClosed}
                                variant="contained"
                            >
                                {isUploading ? <CircularProgress size={24} /> : 'Subir'}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Grid>
                </SRLWrapper>
		</React.Fragment>
	);

}

const structuredSelector = createStructuredSelector({
});
const mapDispatchToProps = {};

export default connect(structuredSelector, mapDispatchToProps)(VisitCheckList)
